import axios from 'axios';
import config from '../config';

const publicFetch = axios.create({
  baseURL: config.API_URL
});

export default publicFetch;
